import firebase from 'firebase/app'
import 'firebase/database'
import store from '@/store'

// models
import tabs from './tabs'
import computed from './computed'
import widgets from './widgets'
import sheets from './sheets'
import dashboards from './dashboards'
import customCode from './custom-code'
import access from './access'
import pivotTable from './pivot-table'
import posts from './posts'
import settings from './settings'
import dataGrid from './data-grid'
import dataGridLogs from './data-grid-logs'
import dashboardModels from './dashboard-models'
import chart from './chart'
import gantt from './gantt'
import gantt_simple from './gantt_simple'
import tipTapEditor from './tipTapEditor'
import fullCalendar from './full-calendar'
import kanban from './kanban'
import workflow from './workflow'
import components from './components'
import files from './files'
import comments from './comments'
import chat from './chat'
import simpleWorkflow from './simple-workflow'

import router from '@/router'

const db = firebase.database()

const service = {
  root: db,
  dashRef: db.ref('dashboards'),
  accessRef: db.ref('access'),
  initialDataRef: db.ref('initialData'),
  getUserId () {
    return store.state.userId
  },
  getRef (ref, manual) {
    let path = ''
    if (manual) {
      path = 'dashboards/' + ref
    } else {
      const dashboard = router.history.current.params.id
      
      if (ref) path = 'dashboards/' + dashboard + '/' + ref
      else path = 'dashboards/' + dashboard
    }
    return db.ref(path)
  },
  getDBRef (ref, manual) {
    let path = ''
    if (manual) {
      path = ref
    } else {
      let dashboard = window.location.pathname.slice(window.location.pathname.lastIndexOf('/') + 1)
      path = 'dashboards/' + dashboard + '/' + ref
    }
    return db.ref(path)
  },
  dbUpdateDataByPath (path, newData, callback) {
    let ref = this.getRef('widgetsData')
    if (path) ref = this.getRef('widgetsData').child(path)
    ref.set(newData)
  },
  getNFLPAUserData (uid, callback) {
    db.ref('nflpaUserData/' + uid).once('value', (snapshot) => {
      callback(null, snapshot.val())
    }, (err) => {
      console.log(err)
      callback(err)
    })
  },
  getProfilesInfo (callback) {
    db.ref('profileInfo').once('value', (snapshot) => {
      callback(snapshot.val())
    })
  },
  getProfileInfo (uid, callback) {
    db.ref('profileInfo/' + uid).once('value', (snapshot) => {
      callback(snapshot.val())
    })
  },
  setProfileInfo (uid) {
    db.ref('profileInfo/' + uid).set({
      name: uid,
      websiteId: uid
    })
  },
  getTrackModels (callback) {
    this.getRef('trackModels').once('value', (snapshot) => {
      callback(snapshot.val())
    })
  },
  setTrackModel (uid, modelKey, modelVal, callback) {
    this.getRef('trackModels')
      .push(modelVal, () => {
        if (callback) callback()
      })
  }
}

const models = {
  tabs,
  computed,
  widgets,
  sheets,
  dashboards,
  customCode,
  access,
  pivotTable,
  settings,
  dataGrid,
  dataGridLogs,
  dashboardModels,
  chart,
  gantt,
  gantt_simple,
  tipTapEditor,
  fullCalendar,
  kanban,
  workflow,
  components,
  files,
  comments,
  chat,
  posts,
  simpleWorkflow,
}

for (let modelName in models) {
  let model = models[modelName](service)
  Object.defineProperty(service, modelName, {
    configurable: false,
    writable: false,
    value: { ...model }
  })
}

export default service
